import { GetServerSideProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { FC, Fragment } from "react";
import Form from "~/components/AIStudioSections/Form";
import Hero from "~/components/AIStudioSections/Hero";
import OurApproach from "~/components/AIStudioSections/OurApproach";
import OurServices from "~/components/AIStudioSections/OurServices";
import OurWorkingProcess from "~/components/AIStudioSections/OurWorkingProcess";
import WeHaveDoneThisBefore from "~/components/AIStudioSections/WeHaveDoneThisBefore";
import WhyChooseCXGenie from "~/components/AIStudioSections/WhyChooseCXGenie";
import Layout from "~/components/Layout";

export const getServerSideProps: GetServerSideProps = async (context) => {
  return {
    props: {
      ...(await serverSideTranslations(context.locale || "en", ["common"])),
    },
  };
};

const AIStudio: FC = () => {
  return (
    <Layout>
      <Hero />
      <OurApproach />
      <OurServices />
      <OurWorkingProcess />
      <WhyChooseCXGenie />
      <WeHaveDoneThisBefore />
      <Form />
    </Layout>
  );
};

export default AIStudio;
